<template>
<v-app>
    <v-snackbar v-model="snackbar" top color="red" :timeout="4000">
        {{ errorMsg }}
        <v-btn color="white" icon @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
    <v-container fluid class="mt-1">
        <v-card class="mx-10">
            <v-card-title>
              <v-img style="max-width: 250px" src="@/assets/logo-vivalis.png"></v-img>
                <v-spacer></v-spacer>
              <span style="color:#007ca7">OFFRE SPECIALE LOA GRATUIT - ENTREPRISES HYUNDAI</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Apport %</th>
                                        <th class="text-left">Duree</th>
                                        <th class="text-left">Apport y compris frais de dossier</th>
                                        <th class="text-left">Loyer TTC hors FGM</th>
                                        <th class="text-left">FGM</th>
                                        <th class="text-left">Cout total hors FGM</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="offre in offres">
                                        <tr :key="offre.id" v-if="offre.niveauApport == selectedApport">
                                            <td class="text-right">{{offre.niveauApport}} %</td>
                                            <td class="text-right">{{offre.duree}}</td>
                                            <td class="text-right">{{FormatPrix(Math.round(CalculeApport(offre)))}}</td>
                                            <td class="text-right">{{FormatPrix(Math.round(CalculeLoyer(offre)))}}</td>
                                            <td class="text-right">{{FormatPrix(Math.round(CalculeFGM(offre)))}}</td>
                                            <td class="text-right">{{FormatPrix(Math.round(CalculeCoutTotalHorsFGM(offre)))}}</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</v-app>
</template>

<script>
export default {
    name: "LoaEntreprises",
    data() {
        return {
            offres: [],
            snackbar: false,
            errorMsg: ''
        }
    },
    mounted() {
        this.getOffres()
    },
    methods: {
        getOffres: function () {
            let params = {}
            params.action = 'getOffres'
            params.type = 'vivalis'
            params.name = 'loasocietes'
            this.axios.post(this.$store.state.rootUrl + 'apiSalesTarifier.php', params)
                .then(data => {
                    this.offres = data.data
                })
                .catch(error => {
                    this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                    this.snackbar = true
                    console.log(error)
                })
        },
        CalculeLoyer: function (offre) {
            let r = offre.th / 12
            let PV = this.montant - (this.montant * offre.plm)
            let FV = this.montant * (offre.dg + offre.vr)
            if (offre.th == 0) {
                return (PV * Math.pow((1 + r), offre.duree) - FV) / offre.duree
            } else {
                return r / (Math.pow((1 + r), offre.duree) - 1) * (PV * Math.pow((1 + r), offre.duree) - FV)
            }
        },
        CalculeFGM(offre) {
            let fgmttc = (((this.montant * (1 - offre.plm - offre.dg - offre.vr))) * (offre.fgm / offre.duree))
            return (fgmttc).toFixed(2)
        },
        CalculeApport(offre) {
            return (this.montant * (offre.plm + offre.dg + offre.fraisdossier))
        },
        CalculeCoutTotalHorsFGM(offre) {
            return (this.montant * (offre.plm + offre.dg + offre.vr + offre.fraisdossier) + (offre.duree * this.CalculeLoyer(offre))) - this.montant
        },
        FormatPrix: function (prix) {
            return new Intl.NumberFormat('de-DE', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(prix)
        }
    },
    computed: {
        montant() {
            return this.$store.state.simulateur.montant
        },
        selectedApport() {
            return this.$store.state.simulateur.selectedApport
        }
    }
}
</script>
